import Vue from "vue";


Vue.filter('formdate',function(dateStr){
    let Time = new Date(dateStr)
    let year = Time.getFullYear();
    let month = Time.getMonth() + 1;//月份的返回值是0-11，需要手动+1
    let day = Time.getDate();
    return year + '-' + month + '-' + day
})